/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchFeatureFlagTemplatePathParams = NonNullable<
  operations['patchFeatureFlagTemplate']['parameters']['path']
>;

export type PatchFeatureFlagTemplateRequestBody = OperationRequestBodyContent<operations['patchFeatureFlagTemplate']>;

export interface Input extends PatchFeatureFlagTemplatePathParams {
  apiVersion?: string;
  body: PatchFeatureFlagTemplateRequestBody;
}

export async function patchFeatureFlagTemplate(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projectKey}/flag-templates/{templateKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
